import { ButtonBase, Stack } from "@mui/material"
import { FilterType } from "../../services/config/enum"
import { useContext, useEffect } from "react"
import { MainContext } from "../../controllers/main"
import { defaultTransition } from "../../services/config/constants"
import { colors } from "../../services/config/colors"
import { useTranslation } from "react-i18next"
import { HelperContext } from "../../controllers/helper"
import Filter from "../global/Filter"
import Title from "../global/Title"
import Input from "../global/Input"
import { StoriesContext } from "../../controllers/stories"

const StoriesCompactFilters = () => {
  const { t } = useTranslation()
  const { selectedFilters, setSelectedFilters } = useContext(MainContext)
  const { loading, getData } = useContext(HelperContext)
  const { searchValue, setSearchValue, getStoriesData, storiesDataLoading } =
    useContext(StoriesContext)

  // get stories data when search value is cleared
  useEffect(() => {
    if (searchValue === "") {
      getStoriesData()
    }
  }, [searchValue])

  return (
    <Stack gap={2} style={{ width: "100%", marginTop: 40 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          getStoriesData()
        }}
      >
        <Input
          value={searchValue ?? ""}
          onChange={(e) => setSearchValue(e.target.value)}
          placeholder={t("search_stories")}
          type="search"
          disabled={loading || storiesDataLoading}
        />
      </form>
      <Stack direction="row" gap={2} style={{ width: "100%", height: 35 }}>
        <Filter
          type={FilterType.sdg}
          selectedOptions={selectedFilters}
          setSelectedOptions={setSelectedFilters}
          variant="compact"
          disableMultipleSelection
        />
        <Filter
          type={FilterType.topic}
          selectedOptions={selectedFilters}
          setSelectedOptions={setSelectedFilters}
          variant="compact"
          disableMultipleSelection
        />
        <ButtonBase
          disabled={loading || !selectedFilters.length}
          disableRipple
          style={{
            borderRadius: 4,
            transition: defaultTransition,
            opacity: selectedFilters.length ? 1 : 0,
          }}
          onClick={() => {
            selectedFilters.splice(0, selectedFilters.length)
            setSelectedFilters([...selectedFilters])
            getData()
          }}
        >
          <Title
            fontSize={14}
            lineHeight="17px"
            color={colors.primary}
            style={{
              transition: defaultTransition,
              opacity: loading ? 0.4 : 1,
            }}
          >
            {t("clear_all")}
          </Title>
        </ButtonBase>
      </Stack>
    </Stack>
  )
}

export default StoriesCompactFilters
